import script from "./gameHeaderBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./gameHeaderBar.vue?vue&type=script&setup=true&lang=ts"

import "./gameHeaderBar.vue?vue&type=style&index=0&id=38847999&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38847999"]])

export default __exports__